// Third-party payment SDK scripts the checkout page can load. Rendered together on
// /[locale]/monitoring/payment-scripts so the weekly payment-page-monitor job (apps/jobs) can
// inventory and hash them; the job keeps its own independent copy as the authorized baseline.

export const CONVERGE_SCRIPT_URLS = {
	live: "https://api.convergepay.com/hosted-payments/PayWithConverge.js",
	sandbox: "https://api.demo.convergepay.com/hosted-payments/PayWithConverge.js",
};

export const ACCEPT_UI_SCRIPT_URLS = {
	live: "https://js.authorize.net/v3/AcceptUI.js",
	sandbox: "https://jstest.authorize.net/v3/AcceptUI.js",
};

// Spreedly Web SDK (headless hosted fields): renders secure iframes for the card number and CVV;
// expiry and cardholder name are collected by our own inputs and passed to `submit`.
export const SPREEDLY_SDK_URL = "https://core.spreedly.com/checkout/sdk/1.0.1/index.js";

// Injected by @stripe/stripe-js's loadStripe rather than by our code.
export const STRIPE_JS_URL = "https://js.stripe.com/v3";

export const MONITORED_PAYMENT_SCRIPT_URLS = [
	CONVERGE_SCRIPT_URLS.live,
	CONVERGE_SCRIPT_URLS.sandbox,
	ACCEPT_UI_SCRIPT_URLS.live,
	ACCEPT_UI_SCRIPT_URLS.sandbox,
	SPREEDLY_SDK_URL,
	STRIPE_JS_URL,
];
